import React, { useState } from 'react';
import { mascot_img_main } from '../../imagepath';
import ReactCardFlip from 'react-card-flip';
import { Button } from 'antd';

const AppMascot = () => {
  const [isFlipped, setIsFlipped] = useState();
  const handleFlip = (e) => {
    e.preventDefault();
    setIsFlipped((value) => !value);
  };
  return (
    <ReactCardFlip isFlipped={isFlipped} flipDirection="vertical">
      <div className="col-lg-6 login-wrap">
        <div className="login-sec-centered">
          <div className="d-flex justify-content-end w-100 pe-5">
            <Button
              type="text"
              shape="circle"
              size="large"
              onClick={handleFlip}
            >
              <i className="fa-solid fa-circle-info text-white fa-xl"></i>
            </Button>
          </div>
          <div className="log-img">
            <img className="img-fluid" src={mascot_img_main} alt="#" />
          </div>
        </div>
      </div>
      <div className="col-lg-6 login-wrap">
        <div className="login-sec-centered text-left text-white">
          <h3>Admin</h3>
          <ul>
            <li>Monitor submitted cases</li>
            <li>Manage clinics & radiologists</li>
            <li>Act as a radiologist</li>
            <li>Oversee accounting</li>
          </ul>
          <Button size="large" onClick={handleFlip}>
            Done
          </Button>
        </div>
      </div>
    </ReactCardFlip>
  );
};

export default AppMascot;
